export const DEFAULT_FADE_TRANSITION_DURATION = 300
